import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";

const ProductBundleView = () => {
  const { id } = useParams(); // product_id
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

  const schoolId = localStorage.getItem("school_id");
  const viewURL = `https://dgps.co.in/api/product/bundle/view/${id}?school_id=${schoolId}`;

  const [data, setData] = useState(null);

  useEffect(() => {
    if (!schoolId || !id) return;
    fetch(viewURL)
      .then((r) => r.json())
      .then((d) => setData(d?.data || null))
      .catch(() => {});
  }, [viewURL, id, schoolId]);

  return (
    <div style={{ display: "flex", minHeight: "100vh", backgroundColor: "#f4f6f8" }}>
      <div style={{ flex: 1 }}>
        <main style={{ padding: 30, maxWidth: 1000, margin: "0px auto" }}>
          <section style={cardStyle}>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <h2 style={titleStyle}>📦 Product Details</h2>
              <Link to="/admin/product-bundle/list" style={btnGhost}>Back to list</Link>
            </div>

            {!data ? (
              <div>Loading...</div>
            ) : (
              <>
                <div style={{ marginBottom: 10 }}>
                  <div style={{ fontSize: 20, fontWeight: 700, color: "#0f172a" }}>{data.product_name}</div>
                  <div style={{ color: "#475569" }}>
                    {data.category_name} › {data.subcategory_name} • Type: {data.product_type}
                  </div>
                </div>

                <div style={{ overflowX: "auto" }}>
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <thead>
                      <tr style={{ background: "#f1f5f9", color: "#334155" }}>
                        <th style={th}>Variant</th>
                        <th style={th}>Class/Size/Range</th>
                        <th style={th}>Cost</th>
                        <th style={th}>Sale</th>
                        <th style={th}>Stock</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data.variants?.length ? (
                        data.variants.map((v, i) => (
                          <tr key={v.variant_id} style={{ background: i % 2 ? "#fff" : "#f8fafc" }}>
                            <td style={td}>{v.variant_name}</td>
                            <td style={td}>
                              {v.class_id ? `Class: ${v.class_id} ` : ""}
                              {v.size ? `Size: ${v.size} ` : ""}
                              {v.height_range || v.weight_range ? `${v.height_range || ""} ${v.weight_range || ""}` : ""}
                            </td>
                            <td style={td}>₹{v.cost_price}</td>
                            <td style={td}>₹{v.sale_price}</td>
                            <td style={td}>{v.stock_qty}</td>
                          </tr>
                        ))
                      ) : (
                        <tr><td colSpan="5" style={td}>No variants found.</td></tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </>
            )}
          </section>
        </main>
      </div>
    </div>
  );
};

const cardStyle = { background: "#ffffff", padding: 20, borderRadius: 12, boxShadow: "0 2px 10px rgba(0,0,0,.05)" };
const titleStyle = { color: "#0f172a", marginBottom: 10, fontWeight: 700, fontSize: 20 };
const th = { textAlign: "left", padding: 10, fontWeight: 600, borderBottom: "1px solid #e2e8f0" };
const td = { padding: 10, borderBottom: "1px solid #f1f5f9", color: "#0f172a", textAlign:"left" };
const btnGhost = { padding: "8px 14px", background: "#e2e8f0", color: "#0f172a", borderRadius: 8, textDecoration: "none", height: 36 };

export default ProductBundleView;
